import { Components } from 'common/consts/components';
import LandingPage from 'templates/LandingPage/LandingPage';
import DebtOverviewPageDataSelector from 'templates/DebtOverviewPageData/DebtOverViewPageDataSelector';
import DirectPaymentPageData from 'templates/DirectPaymentPageData/DirectPaymentPageData';
import UpdatePaymentPlanStartPage from 'templates/UpdatePaymentPlanStartPage/UpdatePaymentPlanStartPage';
import CustomerProfilePageData from 'templates/CustomerProfilePageData/CustomerProfilePageData';
import UpdatePaymentPlanChangeAmountPageData from 'templates/UpdatePaymentPlanChangeAmountPageData/UpdatePaymentPlanChangeAmountPageData';
import ChooseYourPlanPageData from 'templates/ChooseYourPlanPageData/ChooseYourPlanPageData';
import PaymentPlanChoosePaymentMethodPageData from 'templates/PaymentPlanChoosePaymentMethodPageData/PaymentPlanChoosePaymentMethodPageData';
import PaymentPlanConfirmManualPageData from 'templates/PaymentPlanConfirmManualPageData/PaymentPlanConfirmManualPageData';
import UpdatePaymentPlanChangeDatePageData from 'templates/UpdatePaymentPlanChangeDatePageData/UpdatePaymentPlanChangeDatePageData';
import EnterDisposableIncomePageData from 'templates/EnterDisposableIncomePageData/EnterDisposableIncomePageData';
import DisposableIncomeTooLowPageData from 'templates/DisposableIncomeTooLowPageData/DisposableIncomeTooLowPageData';
import UpdatePaymentPlanConfirmPageData from 'templates/UpdatePaymentPlanConfirmPageData/UpdatePaymentPlanConfirmPageData';
import UpdatePaymentPlanSummaryPageData from 'templates/UpdatePaymentPlanSummaryPageData/UpdatePaymentPlanSummaryPageData';
import PaymentPlanConfirmPageData from 'templates/PaymentPlanConfirmPageData/PaymentPlanConfirmPageData';
import PaymentPlanSummaryPageData from 'templates/PaymentPlanSummaryPageData/PaymentPlanSummaryPageData';
import DirectPaymentSummaryPageData from 'templates/DirectPaymentSummaryPageData/DirectPaymentSummaryPageData';
import UpdatePaymentPlanChangePaymentTypePageData from 'templates/UpdatePaymentPlanChangePaymentTypePageData/UpdatePaymentPlanChangePaymentTypePageData';
import UpdatePaymentPlanChangePaymentTypeConfirmPageData from 'templates/UpdatePaymentPlanChangePaymentTypeConfirmPageData/UpdatePaymentPlanChangePaymentTypeConfirmPageData';
import PaymentPlanConfirmSchedulePageData from 'templates/PaymentPlanConfirmSchedulePageData/PaymentPlanConfirmSchedulePageData';
import EditEmailPageData from 'templates/EditEmailPageData/EditEmailPageData';
import EditAddressPageData from 'templates/EditAddressPageData/EditAddressPageData';
import EditPhonePageData from 'templates/EditPhonePageData/EditPhonePageData';
import OfferDirectPaymentPageData from 'templates/OfferDirectPaymentPageData/OfferDirectPaymentPageData';
import LoginPageData from 'templates/LoginPageData/LoginPageData';
import RegistrationVerifyEmailSmsPageData from 'templates/RegistrationVerifyEmailSmsPageData/RegistrationVerifyEmailSmsPageData';
import IncomeAndExpendituresPageData from 'templates/IncomeAndExpendituresPageData/IncomeAndExpendituresPageData';
import ResetPasswordPageData from 'templates/ResetPasswordPageData/ResetPasswordPageData';
import RegistrationVerifyOtpPageData from 'templates/RegistrationVerifyOtpPageData/RegistrationVerifyOtpPageData';
import RequestCallBackPageData from 'templates/RequestCallBackPageData/RequestCallBackPageData';
import GenericErrorPageData from 'templates/GenericErrorPageData/GenericErrorPageData';
import NewUserRegistrationPageData from 'templates/NewUserRegistrationPageData/NewUserRegistrationPageData';
import VerifyIdentityWithoutDebtReferencePageData from 'templates/VerifyIdentityWithoutDebtReferencePageData/VerifyIdentityWithoutDebtReferencePageData';
import ContactDetailsUpdateConfirmationPageData from'templates/ContactDetailsUpdateConfirmationPageData/ContactDetailsUpdateConfirmationPageData';
import EmailVerificationPageData from 'templates/EmailVerificationPageData/EmailVerificationPageData';
import MobileVerificationPageData from 'templates/MobileVerificationPageData/MobileVerificationPageData';
import PaymentPlanConfirmPolandPageData from 'templates/PaymentPlanConfirmPolandPageData/PaymentPlanConfirmPolandPageData';
import UpdatePaymentPlanConfirmTablePageData from 'templates/UpdatePaymentPlanConfirmTablePageData/UpdatePaymentPlanConfirmTablePageData';
import TransactionHistoryPageData from 'templates/TransactionHistoryPageData/TransactionHistoryPageData';
import DocumentPageData from 'templates/DocumentsPageData/DocumentPageData';

export const ComponentsMap = new Map()
  .set(Components.LANDING_PAGE, LandingPage)
  .set(Components.DEBT_OVERVIEW_PAGE_DATA, DebtOverviewPageDataSelector)
  .set(Components.DIRECT_PAYMENT_FRANCE_PAGE_DATA, DirectPaymentPageData)
  .set(Components.LANDING_PAGE, LandingPage)
  .set(Components.DEBT_OVERVIEW_PAGE_DATA, DebtOverviewPageDataSelector)
  .set(
    Components.UPDATE_PAYMENT_PLAN_START_PAGE_DATA,
    UpdatePaymentPlanStartPage,
  )
  .set(Components.CUSTOMER_PROFILE_PAGE_DATA, CustomerProfilePageData)
  .set(Components.DIRECT_PAYMENT_FRANCE_PAGE_DATA, DirectPaymentPageData)
  .set(Components.DIRECT_PAYMENT_GERMANY_PAGE_DATA, DirectPaymentPageData)
  .set(Components.DIRECT_PAYMENT_ITALY_PAGE_DATA, DirectPaymentPageData)
  .set(Components.DIRECT_PAYMENT_BELGIUM_PAGE_DATA, DirectPaymentPageData)
  .set(Components.DIRECT_PAYMENT_POLAND_PAGE_DATA, DirectPaymentPageData)
  .set(Components.DIRECT_PAYMENT_NETHERLANDS_PAGE_DATA, DirectPaymentPageData)
  .set(Components.DIRECT_PAYMENT_SPAIN_PAGE_DATA, DirectPaymentPageData)
  .set(
    Components.UPDATE_PAYMENT_PLAN_CHANGE_AMOUNT_PAGE_DATA,
    UpdatePaymentPlanChangeAmountPageData,
  )
  .set(Components.CHOOSE_YOUR_PLAN_PAGE_DATA, ChooseYourPlanPageData)
  .set(
    Components.PAYMENT_PLAN_CHOOSE_PAYMENT_METHOD_PAGE_DATA,
    PaymentPlanChoosePaymentMethodPageData,
  )
  .set(
    Components.PAYMENT_PLAN_CONFIRM_MANUAL_PAGE_DATA,
    PaymentPlanConfirmManualPageData,
  )
  .set(
    Components.UPDATE_PAYMENT_PLAN_CHANGE_DATE_PAGE_DATA,
    UpdatePaymentPlanChangeDatePageData,
  )
  .set(
    Components.ENTER_DISPOSABLE_INCOME_PAGE_DATA,
    EnterDisposableIncomePageData,
  )
  .set(
    Components.DISPOSABLE_INCOME_TOO_LOW_PAGE_DATA,
    DisposableIncomeTooLowPageData,
  )
  .set(
    Components.UPDATE_PAYMENT_PLAN_CONFIRM_PAGE_DATA,
    UpdatePaymentPlanConfirmPageData,
  )
  .set(
    Components.UPDATE_PAYMENT_PLAN_SUMMARY_PAGE_DATA,
    UpdatePaymentPlanSummaryPageData,
  )
  .set(Components.PAYMENT_PLAN_CONFIRM_PAGE_DATA, PaymentPlanConfirmPageData)
  .set(Components.PAYMENT_PLAN_SUMMARY_PAGE_DATA, PaymentPlanSummaryPageData)
  .set(
    Components.DIRECT_PAYMENT_SUMMARY_PAGE_DATA,
    DirectPaymentSummaryPageData,
  )
  .set(
    Components.UPDATE_PAYMENT_PLAN_CHANGE_PAYMENT_TYPE_PAGE_DATA,
    UpdatePaymentPlanChangePaymentTypePageData,
  )
  .set(
    Components.UPDATE_PAYMENT_PLAN_CHANGE_PAYMENT_TYPE_CONFIRM_PAGE_DATA,
    UpdatePaymentPlanChangePaymentTypeConfirmPageData,
  )
  .set(Components.PAYMENT_PLAN_SUMMARY_PAGE_DATA, PaymentPlanSummaryPageData)
  .set(
    Components.PAYMENT_PLAN_CONFIRM_SCHEDULE_PAGE_DATA,
    PaymentPlanConfirmSchedulePageData,
  )
  .set(Components.EDIT_EMAIL_PAGE_DATA, EditEmailPageData)
  .set(Components.EDIT_ADDRESS_PAGE_DATA, EditAddressPageData)
  .set(Components.EDIT_PHONE_PAGE_DATA, EditPhonePageData)
  .set(Components.OFFERR_DIRECT_PAYMENT_PAGE_DATA, OfferDirectPaymentPageData)
  .set(Components.LOGIN_PAGE_DATA, LoginPageData)
  .set(
    Components.REGISTRATION_VERIFY_EMAIL_SMS_PAGE_DATA,
    RegistrationVerifyEmailSmsPageData,
  )
  .set(
    Components.INCOME_AND_EXPENDITURES_PAGE_DATA,
    IncomeAndExpendituresPageData,
  )
  .set(Components.RESET_PASSWORD_PAGE_DATA, ResetPasswordPageData)
  .set(
    Components.REGISTRATION_VERIFY_OTP_PAGE_DATA,
    RegistrationVerifyOtpPageData,
  )
  .set(
    Components.REQUEST_CALLBACK_PAGE_DATA,
    RequestCallBackPageData
  )
  .set(
    Components.VERIFY_IDENTITY_BELGIUM_PAGE_DATA,
    NewUserRegistrationPageData,
  )
  .set(Components.GENERIC_ERROR_PAGE,GenericErrorPageData)  
  .set(Components.VERIFY_IDENTITY_FRANCE_PAGE_DATA, NewUserRegistrationPageData)
  .set(
    Components.VERIFY_IDENTITY_GERMANY_PAGE_DATA,
    NewUserRegistrationPageData,
  )
  .set(Components.VERIFY_IDENTITY_ITALY_PAGE_DATA, NewUserRegistrationPageData)
  .set(
    Components.VERIFY_IDENTITY_NETHERLANDS_PAGE_DATA,
    NewUserRegistrationPageData,
  )
  .set(Components.VERIFY_IDENTITY_POLAND_PAGE_DATA, NewUserRegistrationPageData)
  .set(Components.VERIFY_IDENTITY_SPAIN_PAGE_DATA, NewUserRegistrationPageData)
  .set(Components.RESET_PASSWORD_PAGE_DATA, ResetPasswordPageData)
  .set(Components.VERIFY_IDENTITY_WITHOUT_DEBTREFERENECE_PAGE_DATA,VerifyIdentityWithoutDebtReferencePageData)
  .set(Components.CONTACT_DETAILS_UPDATE_CONFIRMATION_PAGE_DATA,ContactDetailsUpdateConfirmationPageData)
  .set(Components.EMAIL_VERIFICATION_PAGE_DATA, EmailVerificationPageData)
  .set(Components.MOBILE_VERIFICATION_PAGE_DATA,MobileVerificationPageData)
  .set(Components.PAYMENT_PLAN_CONFIRM_POLAND_PAGE_DATE, PaymentPlanConfirmPolandPageData)
  .set(Components.UPADTE_PAYMENT_PLAN_CONFIRM_TABLE_PAGE_DATA, UpdatePaymentPlanConfirmTablePageData)
  .set(Components.TRANSACTION_HISTORY_PAGE_DATA, TransactionHistoryPageData)
  .set(Components.DOCUMENTS_PAGE_DATA,DocumentPageData);